import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import getBodyVisitInformationQueryOption from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVisitInformation/getBodyVisitInformationQueryOption';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بیمه گذار / کارشناسی" header="titleHeader">
      <VehicleShowVisitInformation />
    </MainLayout>
  );
};
const VehicleShowVisitInformation = () => {
  const { id } = useParams();
  const [convertedData, setConvertedData] = useState<
    { label: string; value: string | number | null }[]
  >([]);
  const { data } = useQuery(
    getBodyVisitInformationQueryOption({
      id: id!,
      source: 'vehicle',
    }),
  );
  useEffect(() => {
    if (data) {
      const temporaryData = [
        {
          label: 'تاریخ بازدید :',
          value: data?.visit_date,
        },
        { label: 'ساعت بازدید :', value: data?.visit_time },
        {
          label: 'تعداد بازدید :',
          value: data?.visit_number,
        },
        {
          label: 'محل بازدید :',
          value: data?.visit_site.label,
        },
        { label: 'مسافت طی شده :', value: data?.distance },
        {
          label: 'طول تعمیر :',
          value: data?.parts_repair_length,
        },
        {
          label: 'آدرس محل بازدید :',
          value: `${data?.visit_province.name},${data?.visit_county.name},${data?.visit_location}`,
        },
      ];
      setConvertedData(temporaryData);
    }
  }, [data]);
  return (
    <Box pt={24}>
      <ShowIncidentParticipantsDataCard
        data={convertedData?.filter((item) => item?.value) || []}
        title="اطلاعات بازدید"
      />
    </Box>
  );
};
